import React from 'react';
import { ReportViewModel } from 'types/report';

/**
 * Comments Module for the Right Panel
 */
type CommentsModuleProps = {
  data?: ReportViewModel | any;
};

const CommentsModule: React.FC<CommentsModuleProps> = ({ data }) => {
  return <div>COMMENTS MODULE</div>;
};

export default CommentsModule;
